import { Component } from '@angular/core';

@Component({
  selector: 'app-full-order-details',
  templateUrl: './full-order-details.component.html'
})
export class FullOrderDetailsComponent {
  showorderstatusdata: boolean = true;
}
